<div *ngIf="diviceXs">
    <mat-carousel timings="200ms ease-in" [slides]="slidesXs?.length" [autoplay]="true" interval="6000" color="white"
        maxWidth="auto" slideHeight="450px" [loop]="true" [maintainAspectRatio]="false" [hideArrows]="false"
        [hideIndicators]="false">

        <mat-carousel-slide *ngFor="let slide of slidesXs; let i = index" [image]="slide.image"
            overlayColor="transparent" [hideOverlay]="false"></mat-carousel-slide>

    </mat-carousel>
</div>

<div *ngIf="!diviceXs" id="carousel">
    <mat-carousel timings="200ms ease-in" [slides]="slides?.length" [autoplay]="true" interval="6000" color="white"
        maxWidth="auto" slideHeight="380px" [loop]="true" [hideArrows]="false" [maintainAspectRatio]="false">

        <mat-carousel-slide *ngFor="let slide of slides; let i = index" [image]="slide.image" overlayColor="transparent"
            [hideOverlay]="false"></mat-carousel-slide>
    </mat-carousel>
</div>

<div id="recommended">
    <h1>RECOMENDADOS</h1>

    <div id="contentRecommended" fxLayout="row" fxLayoutAlign="space-around center" *ngIf="!diviceXs">

        <div id="imgRecommendedOne" fxFlex="45">
        </div>

        <div id="imgRecommendedTwo" fxFlex="45" fxLayoutAlign="none end">

            <div id="textInfo" fxLayout="row" fxLayoutAlign="space-between center">

                <div id="costGeneral" fxLayout="row" fxLayoutAlign="space-around center">
                    <figure></figure>
                    <figcaption>700.000</figcaption>
                </div>
                <div id="costPoints">
                    <h3>Puntos</h3>
                    <p>17.000</p>
                </div>
            </div>
        </div>
    </div>

    <div id="contentRecommended" fxLayout="column" fxLayoutAlign="space-around center" *ngIf="diviceXs">

        <div id="imgRecommendedOne" >
        </div>

        <div id="imgRecommendedTwo" fxLayoutAlign="none end">

            <div id="textInfo" fxLayout="row" fxLayoutAlign="space-between center">

                <div id="costGeneral" fxLayout="row" fxLayoutAlign="space-around center">
                    <figure></figure>
                    <figcaption>700.000</figcaption>
                </div>

                <div id="costPoints">
                    <h3>Puntos</h3>
                    <p>17.000</p>
                </div>
            </div>
        </div>

    </div>

</div>